export const makeFiltersRow = ({ showFilters }: MakeFiltersRowProps) => {
  return {
    CanExport: 0,
    CanPrint: 0,
    id: "filterRow",
    Kind: "Filter",
    Visible: showFilters ? 1 : 0,
  }
}

type MakeFiltersRowProps = {
  showFilters: boolean
}
